/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteCollectionPackagingUnit$Params {

/**
 * UUID of the parent product (PackagingUnit)
 */
  packagingUnitId: string;

/**
 * UUID of the child collection packaging unit to delete
 */
  collectionPackagingUnitId: string;
}

export function deleteCollectionPackagingUnit(http: HttpClient, rootUrl: string, params: DeleteCollectionPackagingUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteCollectionPackagingUnit.PATH, 'delete');
  if (params) {
    rb.path('packagingUnitId', params.packagingUnitId, {});
    rb.path('collectionPackagingUnitId', params.collectionPackagingUnitId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteCollectionPackagingUnit.PATH = '/products/{packagingUnitId}/collections/{collectionPackagingUnitId}';
